import React, { Fragment, useEffect, useState } from 'react';
import './testResult.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import Stepper from './stepper';
import { useDispatch, useSelector } from 'react-redux';
import { checkValidTest, getSelectedTests, updateTestName, reorderTest, removeFromSelected, getAdditionalQuestion, getNextAdditionalQuestion, saveSelectQuestion, updateTest, selectOneQuestion, removeQuestion } from '../../../Redux/ActionCreators/testLibraryAction';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AddTestModal from '../../../utils/addTestModal';
import TestDetailDrawer from '../../../utils/testDetailDrawer';
import { Table } from 'react-bootstrap';
import { Dialog } from '@mui/material';




export default function AddQuestion() {
    const [isOpen, setIsOpen] = useState(false);
    const [testName, setTestName] = useState('');
    const [testNameErr, setTestNameErr] = useState('');
    const [description, setDescription] = useState('');
    const [isQuestionList, setIsQuestionList] = useState(false);
    const [query, setQuery] = useState('');
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [openDetail, setOpenDetail] = useState(false);
    const [shouldValidate, setShouldValidate] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { selectedTests, testDetails, isQuestionLoading, additionalQuestions, totalQues, selectedQuestion, deleteIds } = useSelector(state => state.testLibrary);
    console.log(location.state)
    const questionsPerPage = 100;

    useEffect(() => {
        if (location.state.isQuestionVisible) {
            setIsQuestionList(true);
        } else {
            setIsQuestionList(false);
            const { testId } = location.state;
            const fetchSelected = async () => {
                setLoading(true);
                await dispatch(getSelectedTests(testId));
                setLoading(false);
            };
            fetchSelected();
        }
    }, [dispatch, location.state])

    const goBack = () => {
        navigate('/home/select-test', {
            state: {
                testId: location.state.testId,
                next: false
            }
        })
    }


    const removeSkill = async (el) => {
        await dispatch(removeFromSelected(el));
    }



    const handleDragEnd = async (result) => {
        if (!result.destination) return
        await dispatch(reorderTest(result));
    }

    const openAdd = () => {
        setIsQuestionList(true);
        dispatch(getAdditionalQuestion(1, '', 1, 100));
    }

    const timerRef1 = React.useRef(null);

    const searchQuestion = (val) => {
        clearTimeout(timerRef1.current);
        setCurrentPage(1);
        setQuery(val);
        timerRef1.current = setTimeout(() => delaySearch(val, 1), 800);
    }

    const delaySearch = async (val, pageNumber) => {
        await dispatch(getAdditionalQuestion(1, val, pageNumber, 100));
    }

    const selectQuestion = (e, detail) => {
        dispatch(selectOneQuestion(e.target.value, e.target.checked, detail));
    }

    const selectDone = () => {
        dispatch(saveSelectQuestion(selectedQuestion));
        setIsQuestionList(false);
    }

    const backToAdd = () => {
        dispatch(saveSelectQuestion([]));
        setIsQuestionList(false);
        setPage(1);
    }

    const openCreate = () => {
        navigate('/create', { state: { edit: false, question: false, detail: null, testId: location.state.testId } })
    }

    const openAddModal = () => {
        setIsOpen(true);
        setTestName(testDetails.testName);
        setDescription(testDetails?.testDescription);
        setTestNameErr('');
        setShouldValidate(false);
    }

    useEffect(() => {
        if (!shouldValidate) return;
        const delay = setTimeout(() => {
            validateNameViaApi(testName);
        }, 500);

        return () => clearTimeout(delay);
    }, [testName, shouldValidate]);



    const validateNameViaApi = async (input) => {

        const res = input !== '' && await dispatch(checkValidTest(input));
        if (res?.payload?.isValid) {
            setTestNameErr('');
        } else {
            setTestNameErr('Test Name already exist');
        }
    };


    const goToQuestion = async () => {
        setLoading(true);
        if (testName.trim('') === '') {
            setTestNameErr('Please Enter Test Name');
            setLoading(false);
        }
        else if (!selectedTests?.length) {
            setTestNameErr('Please select Tests');
            setLoading(false);
        }
        else {

            let obj = {
                "testName": testName,
                testDescription: description,
                testId: location.state.testId
            }
            const res = await dispatch(updateTestName(obj));

            if (res?.type === "UPDATE_TEST_NAME") {
                await setIsOpen(false);
                setTestNameErr('');
            }
        }
        setLoading(false);
    }

    const removeQues = async (el) => {
        await dispatch(removeQuestion(el));
    }

    const goToPreview = async () => {
        setLoading(true);
        let obj = {
            "testId": location.state.testId,
            "testName": testDetails?.testName,
            "testDescription": testDetails?.testDescription,
            "tests": selectedTests?.map((el, i) => [{ testId: el.testID, levelId: el.testLevel, orderId: i + 1, testDetailId: el.testDetailId ? el.testDetailId : 0, languageId: el.languageId }][0]),
            questions: selectedQuestion?.map((el, i) => [{ questionId: el.questionID, testDetailId: el.testDetailId ? el.testDetailId : 0 }][0]),
            "deletedTestDetailIds": [...new Set(deleteIds)]
        }

        const res = await dispatch(updateTest(obj));
        if (res?.type === "UPDATE_TEST") {
            const jobId = testDetails?.jobId;

            if (jobId) {
                navigate(`/jobs/${jobId}/candidates`, { state: { jobId } });
            } else {
                navigate('/home/invite-preview', {
                    state: {
                        testId: location.state.testId,
                        testDetails: testDetails,
                        myTest: false
                    }
                });
            }
        }
        setLoading(false);
    }

    
    // Pagination component 
    const Pagination = ({ currentPage, totalPages, paginate }) => {
        const getPageNumbers = () => {
        if (totalPages <= 4) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        } else if (currentPage <= 3) {
            return [1, 2, 3, "...", totalPages];
        } else if (currentPage >= totalPages - 2) {
            return [1, "...", totalPages - 2, totalPages - 1, totalPages];
        } else {
            return [
            1,
            "...",
            currentPage - 1,
            currentPage,
            currentPage + 1,
            "...",
            totalPages,
            ];
        }
        };
    
        return (
        <div className="pagination">
            <div className="pagination-info">
            {additionalQuestions.length > 0 ? (
                <span>
                Showing <strong>1</strong>-
                <strong>
                    {Math.min(currentPage * questionsPerPage, totalQues)}
                </strong>{" "}
                of <strong>{totalQues}</strong>
                </span>
            ) : (
                <span>Showing 0-0 of 0</span>
            )}
            </div>
            <div className="pagination-buttons">
            <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <img src="/images/leftarrow-icon.svg" alt="" />
            </button>
            {getPageNumbers().map((page, index) => (
                <button
                key={index}
                onClick={() => (page === "..." ? null : paginate(page))}
                className={currentPage === page ? "active" : ""}
                disabled={page === "..."}
                >
                {page}
                </button>
            ))}
            <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}
            >
                <img
                src="/images/leftarrow-icon.svg"
                alt=""
                style={{ rotate: "180deg" }}
                />
            </button>
            </div>
        </div>
        );
    };

    // Paginate function
    const paginate = (pageNumber) => {
        const totalPages = Math.ceil(totalQues / questionsPerPage);
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        dispatch(getNextAdditionalQuestion(1, query, pageNumber, questionsPerPage));
    }

    return (
        <div className='gappeo-test-results'>
            <Dialog
                className='screen-loader'
                open={loading}
                onClose={() => { }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                Loading ...
            </Dialog>

            {
                !isQuestionList ?
                    <Fragment>
                        <div className='gappeo-test-header'>
                            <div className='gappeo-test-header-top'>
                                {testDetails?.testName.length > 0 ?  <h4>{testDetails?.testName}</h4> : <h4>Test Name</h4> }
                                
                            </div>
                            <Stepper
                                type='add-question'
                                goBack={goBack}
                                goNext={goToPreview}
                            />
                        </div>

                        <div className='gappeo-test-lists d-flex flex-wrap'>
                            <div className='gappeo-add-question'>
                                {window.innerWidth > 767 ? null :
                                    <div className='gappeo-mobile-header'>
                                        <div className='selected-list-header d-flex justify-content-between align-items-end'>
                                            <div>
                                                <h4>Assessment Summary</h4>
                                                <h4 className='d-flex align-items-center' style={{ fontSize: 18 , textAlign:'left'}}>{testDetails?.testName}&nbsp;&nbsp;
                                                    <img src='/images/edit-icon.svg' alt='' className='cursor-pointer' onClick={() => openAddModal()} /></h4>
                                                <h5 >{testDetails?.testDetails?.tests?.length} test | {testDetails?.questionCount} Qs | {testDetails?.duration} Mins</h5>
                                                <p>Level: {testDetails?.testLevelName}</p>
                                            </div>
                                            <button className='outline-btn ms-4' onClick={() => setOpenDetail(true)}>View details</button>
                                        </div>
                                    </div>
                                }
                                <div className='gappeo-test-addquestions'>
                                    <div className='d-flex align-item-center'>
                                        <div className='add-question d-none'>
                                            <h3>Qualifying Questions</h3>
                                            <button className='outline-btn' onClick={() => openAdd()}>+&nbsp;&nbsp;Add Question</button>
                                            <div className='question-list'></div>
                                        </div>
                                        {/* <div style={{ borderLeft: '1px solid #D7DADB', minHeight: 450 }}></div> */}
                                        <div className='add-question'>
                                            <h3>Additional Questions</h3>
                                            {selectedQuestion.length > 0 ?
                                            <div className='add-questions-filed'>
                                                <div className='question-list'>
                                                    {
                                                        selectedQuestion && selectedQuestion?.map((el, i) => {
                                                            return (
                                                                <div className='question' key={el?.questionID}>
                                                                    <div className='d-flex justify-content-between aign-items-center mt-2'>
                                                                        <div>
                                                                            <h4 className='elipsis-2' dangerouslySetInnerHTML={{ __html: el?.question }} />
                                                                            {/* {el?.questionTypeName === 'Multiple Choice' ?
                                                                                <img src='/images/mcq.svg' alt='' /> :
                                                                                <img src='/images/essay.svg' alt='' width={20} />
                                                                            } */}
                                                                            <span>{el?.questionTypeName}</span>
                                                                        </div>
                                                                        <div>
                                                                            <img src='/images/cross-icon.svg' className='cursor-pointer' onClick={() => removeQues(el)} alt='' />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <button className='outline-btn1' onClick={openAdd}>+&nbsp;&nbsp;Add Question</button>
                                            </div> : 
                                            <div className='add-questions-tab'>
                                                <p>No questions added</p>
                                                <button className='outline-btn' onClick={openAdd}>+&nbsp;&nbsp;Add Question</button>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    {window.innerWidth > 767 &&
                                        <div className='next-btn'>
                                            <button disabled={loading} onClick={goToPreview} >NEXT</button>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div style={{width:'25%', padding:'12px 12px 12px 0'}}>
                                <div className='selected-test mt-0'>
                                    <div className='selected-list-header'>
                                        <h4>Assessment Summary</h4>
                                        <h4 className='d-flex align-items-center' style={{ fontSize: 18, textAlign:'left' }}>{testDetails?.testName}&nbsp;&nbsp;
                                            <img src='/images/edit-icon.svg' alt='' className='cursor-pointer' onClick={() => openAddModal()} /></h4>
                                        <h5>{testDetails?.testDetails?.tests?.length} test | {testDetails?.questionCount} Qs | {testDetails?.duration} Mins</h5>
                                        <p>Level {testDetails?.testLevelName}</p>
                                    </div>
                                    <div className='selected-list'>
                                        <h1>Selected Tests</h1>
                                        <DragDropContext onDragEnd={handleDragEnd}>
                                            <Droppable droppableId={'2111'}>
                                                {
                                                    (provided) => (
                                                        <div  {...provided.droppableProps} ref={provided.innerRef}>
                                                            {selectedTests && selectedTests?.map((el, index) => {
                                                                return (
                                                                    <Draggable key={el.testID} draggableId={el.testID.toString()} index={index} >
                                                                        {
                                                                            (provided) => (
                                                                                <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} className='selected-list-item'>
                                                                                    <div className='d-flex'>
                                                                                        <img src='/images/drag.svg' alt='' width={16} />&nbsp;&nbsp;
                                                                                        <div>
                                                                                            <h1>{el.testName}</h1>
                                                                                            <p>{el.testLevelName} | {el.questionCount} Qs | {el.duration} Mins | {el.languageId === 1 ? 'en' : el.languageId === 2 ? 'es' : (el.languageId === 3) ? 'pt' : (el.languageId === 4) ? 'pt' : 'it'}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <img src='/images/delete-icon.svg' onClick={() => removeSkill(el)} alt='' width={16} />
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </Draggable>
                                                                )
                                                            })}
                                                            {provided.placeholder}
                                                        </div>

                                                    )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                    :
                    <div className='gappeo-question-list'>
                        <div className='question-list-header'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className='d-flex'>
                                    <img src='/images/back.svg' alt='' className='cursor-pointer' onClick={backToAdd} />&nbsp;&nbsp;
                                    <h4>Add Additional Question </h4>
                                </div>
                                <button className='add-questions-btn'onClick={() => openCreate()}>+&nbsp;&nbsp;Create Question</button>
                            </div>
                        </div>
                        <div className='additional-questions-section'>
                            <div className='d-flex justify-content-between align-items-center flex-wrap' style={{padding:'16px'}}>
                                <div className="has-search"  >
                                    <span className="form-control-feedback" >
                                        <img src="/images/search.svg" alt='' />
                                    </span>
                                    <input type="search" className="form-control" value={query} placeholder='Search for a question title' onChange={(e) => searchQuestion(e.target.value)} />
                                </div>
                                {/* <h5>View Question({selectedQuestion?.length})</h5> */}
                                <button onClick={() => selectDone()}>Questions Added({selectedQuestion?.length})</button>
                            </div>
                            {isQuestionLoading ?
                                ('Loading..') :
                                (
                                    <Table responsive className='assessment-table table'>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>QUESTIONS</th>
                                                <th>QUESTIONS TYPE</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        {additionalQuestions?.length > 0 ? (
                                            <>
                                                <tbody>
                                                    {additionalQuestions && additionalQuestions?.map((el, i) => {
                                                        return (
                                                            <tr>
                                                                <td >
                                                                    <input type='checkbox' style={{ width: 16, height: 16 }} value={el.questionID} checked={el.isChecked} onChange={(e) => selectQuestion(e, el)} />
                                                                </td>
                                                                <td>
                                                                    <div className='elipsis-2' dangerouslySetInnerHTML={{ __html: el.question }} />
                                                                </td>
                                                                <td >
                                                                    {/* {el.questionTypeName === 'Multiple Choice' ?
                                                                        <img src='/images/mcq.svg' alt='' /> :
                                                                        <img src='/images/essay.svg' alt='' width={20} />
                                                                    }&nbsp;&nbsp;
                                                                    {window.innerWidth > 767 ? null : <br />} */}
                                                                    {el.questionTypeName}
                                                                </td>
                                                                <td><img src='/images/threedots-vertical.svg' alt='' /></td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </>
                                        )
                                        :
                                        (
                                            <div className='empty-list'>
                                                <img src='/images/magnifier.svg' alt='' />
                                                <div className='mt-2'>
                                                    <h3>No question found</h3>
                                                </div>
                                            </div>
                                        )}
                                    </Table>
                                )   
                            }
                        </div>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(totalQues / questionsPerPage)}
                            paginate={paginate}
                        />
                    </div>
            }

            {window.innerWidth < 767 &&
                <TestDetailDrawer
                    openDetail={openDetail}
                    setOpenDetail={() => setOpenDetail(false)}
                    handleDragEnd={handleDragEnd}
                    removeSkill={removeSkill}
                    selectedTests={selectedTests}
                    testDetails={testDetails}
                    selectedQuestion={selectedQuestion}
                />
            }

            <AddTestModal
                edit={true}
                isOpen={isOpen}
                setIsOpen={() => setIsOpen(false)}
                testName={testName}
                testNameErr={testNameErr}
                setTestName={(e) => {
                    setTestName(e)
                    setShouldValidate(true);
                }}
                setTestNameErr={(e) => setTestNameErr(e)}
                description={description}
                setDescription={(val) => setDescription(val)}
                goToQuestion={goToQuestion}
                loading={loading}
            />
        </div >
    )
}
